import React, { useState, useEffect } from "react";
import MUIDataTable from "mui-datatables";
import Loader from "../../Loader";

const StrategyAssetTable = ({ strategyData }) => {
  const [strategy, setStrategy] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (strategyData && strategyData.length > 0) {
      const assetIdGroups = {};

      strategyData?.forEach((strategyItem) => {
        const assets = strategyItem?.assetsVariance || [];

        assets.forEach((asset) => {
          const assetId = asset?.assetId;
          if (!assetIdGroups[assetId]) {
            assetIdGroups[assetId] = {
              assetName: asset?.assetName,
              quantity: 0,
              currentPortfolio: 0,
              returns: 0,
              costQuantity: 0,
              currentPrice: asset?.currentPrice,
            };
          }
          assetIdGroups[assetId].costQuantity += asset?.quantity * asset?.cost;
          assetIdGroups[assetId].returns += asset?.returns;
          assetIdGroups[assetId].quantity += asset?.quantity;
          assetIdGroups[assetId].currentPortfolio += asset?.currentPortfolio;
        });
      });

      const sumArray = Object.keys(assetIdGroups).map((assetId) => ({
        "Asset Name": assetIdGroups[assetId].assetName,
        Quantity: assetIdGroups[assetId].quantity || "",
        Price: assetIdGroups[assetId].currentPrice || "",
        "Market Value": assetIdGroups[assetId].currentPortfolio || "",
        "Return %":
          assetIdGroups[assetId].returns /
            assetIdGroups[assetId].costQuantity || "",
      }));

      setStrategy(sumArray);
      setLoading(false);
    } else {
      setError("Error loading data. Please try again.");
      setLoading(false);

      setStrategy([]);
    }
  }, [strategyData]);
  const columns = [
    {
      name: "Asset Name",
      options: {
        filter: true,
        customBodyRender: (value) => {
          return <div style={{ marginLeft: "20px" }}>{value}</div>;
        },
      },
    },
    {
      name: "Quantity",
      options: {
        filter: true,
        customBodyRender: (value) => {
          return <div style={{ marginLeft: "20px" }}>{value?.toFixed(2)}</div>;
        },
      },
    },
    {
      name: "Price",
      options: {
        filter: true,
        customBodyRender: (value) => {
          return <div style={{ marginLeft: "20px" }}>{value?.toFixed(2)}</div>;
        },
      },
    },
    {
      name: "Market Value",
      options: {
        filter: true,
        customBodyRender: (value) => {
          return <div style={{ marginLeft: "20px" }}>{value?.toFixed(2)}</div>;
        },
      },
    },
    {
      name: "Return %",
      options: {
        customBodyRender: (value) => {
          return <div style={{ marginLeft: "20px" }}>{value?.toFixed(2)}%</div>;
        },
      },
    },
  ];

  const options = {
    filter: true,
    filterType: "dropdown",
    responsive: "standard",
    selectableRows: "none",
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : error ? (
        <p>{error}</p>
      ) : (
        <div style={{ marginTop: "20px", width: "100%" }}>
          <MUIDataTable
            data={strategy}
            options={options}
            columns={columns}
            style={{
              width: "1000px",
            }}
          />
        </div>
      )}
    </>
  );
};

export default StrategyAssetTable;
